import request from '@/router/axios';

export const getCarList = (current, size, params, search) => {
    return request({
        url: '/api/blade-loanCarManage/loanCarManage/pageDate',
        method: 'post',
        data: {
            ...params,
            ...search,
            current,
            size
        }
    })
}

export const getCarDetail = (id) => {
    return request({
        url: `/api/blade-loanCarManage/loanCarManage/sellCarDetail/${id}`,
        method: 'get',
    })
}

export const sellCar = (from) => {
    return request({
        url: '/api/blade-loanCarManage/loanCarManage/sellCar',
        method: 'post',
        data: from
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/v2/blade-loanCarManagePosition/loanCarManagePosition/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/v2/blade-loanCarManagePosition/loanCarManagePosition/save',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/v2/blade-loanCarManagePosition/loanCarManagePosition/update',
        method: 'post',
        data: row
    })
}